import { getInjector, getRootScope } from '@/services/angularjs-bridge';

export type ContactsTab = 'partners' | 'community' | 'invitations' | 'search';

const PAGE_TABS = new Set<ContactsTab>(['partners', 'community', 'invitations', 'search']);

/** Page tab implied by the location hash. Pending and requested stay on invitations. */
export function contactsTabForHash(hash: string): ContactsTab | undefined {
    const value = hash.replace(/^#/, '').split(/[/?]/)[0];
    if (value === 'pending' || value === 'requested') {
        return 'invitations';
    }
    if (PAGE_TABS.has(value as ContactsTab)) {
        return value as ContactsTab;
    }
    return undefined;
}

/** Keep the Angular `$location` hash in sync with the contacts tabs. */
export function setLocationHash(suburl: string) {
    try {
        const injector = getInjector();
        const root = getRootScope(injector);
        const location = injector.get('$location');
        root.$applyAsync(() => {
            location.hash(suburl);
        });
    } catch {
        window.location.hash = suburl;
    }
}
